import React from "react";
import Advertise from "./Advertise";
import Layout from "./Layout";

const Faqs = () => {
  return (
    <Layout title="Frequently Asked Questions" path="faqs">
      <section className="faq-section section-padding" id="faqs">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-md-8 mb-4">
              <div className="faq-content">
                <h3>Frequently Asked Questions</h3>

                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        What is just59?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <strong>just59</strong> is a website that provides a
                        wide range of free online calculators for finance,
                        health, fitness, and general use. Our goal is to
                        simplify complex calculations and make them easily
                        accessible to everyone. Whether you're managing your
                        finances, tracking your health, or solving math
                        problems, we are here to help.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Are the calculators free to use?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Yes! All the calculators on <strong>just59</strong> are
                        completely free to use. We believe in providing valuable
                        tools at no cost to our users.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Where do you source the formulas used in your
                        calculators?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        The formulas used in our calculators are sourced from
                        trusted textbooks, reputable academic references, and
                        industry-standard methods. We ensure that our
                        calculators are based on reliable and well-established
                        formulas to provide accurate results.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Are the health-related calculators reviewed by
                        professionals?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Yes, all health-related calculators on{" "}
                        <strong>just59</strong> are reviewed and approved by
                        certified medical professionals. This ensures that the
                        information provided is both accurate and safe for
                        users.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        Can I use the calculators for any type of calculation?
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Our calculators cover a wide range of categories,
                        including finance, health, fitness, and math. However,
                        if you need a specific type of calculation not yet
                        available, please let us know, and we may add it to the
                        site in the future.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        Is just59 open-source?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        While <strong>just59</strong> itself is not open-source,
                        we do use open-source JavaScript components in some of
                        our calculators. These components are licensed under
                        various open-source licenses to ensure transparency and
                        efficiency.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSeven">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        Who owns just59?
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <strong>just59</strong> is owned and operated by{" "}
                        <strong>just59 Technologies</strong>. We are
                        committed to providing free and reliable tools for
                        everyone, with the goal of making online calculators
                        accessible to all users.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Advertise />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Faqs;
